export * from './tag-summary';
export * from './tag-summary-factory';
//# sourceMappingURL=index.js.map